module.exports = __webpack_public_path__ + "static/media/7. Raíces del alma, Mixta en tela, 140 x 185 cm, 2016 copy.a34a3e98.png";